import React from 'react';

import { Modal } from '@mui/material';

import { colours } from 'src/constants/colours';
import Avatar from 'src/components/ui/Avatar';
import Icon from 'src/components/ui/Icon';

import type { Medium } from 'src/types/__generated__/graphql';

import type { ModalProps } from 'src/hooks/useModalOpenState';
import { styledComponent, styledTag } from 'src/utils/styled';
import useBreakpoints from 'src/hooks/useBreakpoints';

const StyledAvatar = styledComponent(Avatar)`
    border: 0.1875rem solid ${colours.white.main};
`;

interface Props extends ModalProps {
    image: Medium | null;
    alt?: string | null;
    isOnCompany?: boolean;
}

const AvatarContainer = styledTag('div')`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    outline: none;
`;

const StyledCloseIcon = styledTag('div')<{ $isMobile?: boolean }>`
    position: absolute;
    top: 1rem;
    ${({ $isMobile }) => `${$isMobile ? 'left' : 'right'}: 1.5rem`};
    color: ${colours.grey.G300};
    svg {
        cursor: pointer !important;
    }

    &:hover {
        color: ${colours.white.main};
    }
`;

const AvatarLightbox: React.FC<Props> = ({ open, onClose, image, alt, isOnCompany }) => {
    const { isMobile } = useBreakpoints();

    return (
        <Modal open={open} onClose={onClose}>
            <>
                <AvatarContainer>
                    <StyledAvatar
                        variant={isOnCompany ? 'rounded' : 'circular'}
                        alt={alt}
                        image={image as Medium}
                        size={isMobile ? 280 : 440}
                    />
                </AvatarContainer>
                <StyledCloseIcon $isMobile={isMobile}>
                    <Icon name="Close" size="2rem" onClick={onClose} />
                </StyledCloseIcon>
            </>
        </Modal>
    );
};

export default AvatarLightbox;
